import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tooltip"]

  show(event) {
    if (!this.hasTooltipTarget) return

    this.tooltipTarget.textContent = event.currentTarget.dataset.tooltip || ""
    this.tooltipTarget.hidden = false
    event.currentTarget.classList.add("is-hovered")
    this.move(event)
  }

  move(event) {
    if (!this.hasTooltipTarget || this.tooltipTarget.hidden) return

    const chartRect = this.element.getBoundingClientRect()
    const targetRect = event.currentTarget.getBoundingClientRect()
    const clientX = Number.isFinite(event.clientX) && event.clientX > 0 ? event.clientX : targetRect.left + (targetRect.width / 2)
    const clientY = Number.isFinite(event.clientY) && event.clientY > 0 ? event.clientY : targetRect.top
    const tooltipWidth = this.tooltipTarget.offsetWidth
    const half = tooltipWidth / 2
    const x = Math.max(half + 8, Math.min(chartRect.width - half - 8, clientX - chartRect.left))
    const y = Math.max(30, clientY - chartRect.top - 8)

    this.tooltipTarget.style.left = `${x}px`
    this.tooltipTarget.style.top = `${y}px`
  }

  hide(event) {
    if (!this.hasTooltipTarget) return

    this.tooltipTarget.hidden = true
    event.currentTarget.classList.remove("is-hovered")
  }
}
